import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IAuthorizationService, PershingTranslationService } from '@pershing/pershing-core';
import { ContactUsBaseComponent } from './contact-us-base.component';

@Component({
    selector: 'contact-us',
    templateUrl: './contact-us.component.html'
})
export class ContactUsComponent extends ContactUsBaseComponent {
    
    constructor(protected dialog: MatDialog,
        protected authorizationService: IAuthorizationService,
        protected translationService: PershingTranslationService) {
            super(dialog, authorizationService, translationService);
    };
}
